export default function CTA() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-gradient-to-br from-purple-900/30 to-pink-900/30 backdrop-blur-sm border border-purple-500/30 rounded-3xl p-12 md:p-16 min-h-[400px] flex flex-col justify-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent leading-tight">
            Ready to upgrade your next night?
          </h2>

          <p className="text-xl text-gray-300 mb-10 leading-relaxed">
            Grab your friends, grab your phone, and let Kuze run the night.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <a href="https://apps.apple.com/app/kuze/id6742669797" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#8B5CF6] to-[#A419E7] rounded-xl text-white hover:opacity-90 transition-all shadow-lg hover:shadow-purple-500/50 whitespace-nowrap cursor-pointer">
              <i className="ri-apple-fill text-2xl"></i>
              <div className="flex flex-col items-start">
                <span className="text-xs font-normal opacity-90">Download on the</span>
                <span className="text-lg font-semibold leading-tight">Apple App Store</span>
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=app.kuze.game" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-[#606FE5] to-[#4758E0] rounded-xl text-white hover:opacity-90 transition-all shadow-lg hover:shadow-blue-500/50 whitespace-nowrap cursor-pointer">
              <i className="ri-google-play-fill text-2xl"></i>
              <div className="flex flex-col items-start">
                <span className="text-xs font-normal opacity-90">Get it on</span>
                <span className="text-lg font-semibold leading-tight">Google Play</span>
              </div>
            </a>
          </div>

          <p className="text-base text-gray-400">
            Free to start. No subscriptions. No ads.
          </p>
        </div>
      </div>
    </section>
  );
}
